type Transition<T> = {
  loading: boolean;
  loaded: boolean;
  value: T;
  pageCount?: number;
};

export interface Resource<T> {
  value: T;
  meta?: any;
  loading: boolean;
  loaded: boolean;
}

export const transition = {
  reset: function <T>(value: T, meta?: any): Resource<T> {
    return {
      loading: false,
      loaded: false,
      value,
      meta: meta,
    };
  },
  loading: function <T>(value: T): Resource<T> {
    return {
      loading: true,
      loaded: false,
      value,
    };
  },
  loaded: function <T>(value: T, meta?: any): Resource<T> {
    return {
      loading: false,
      loaded: true,
      value,
      meta,
    };
  },
  clone: function <T, TResult>(transition: Transition<T>, value: TResult): Transition<TResult> {
    return {
      ...transition,
      value,
    };
  },
};
